@import '../../utils/global.module.less';

.title {
    font-family: 'Hanken Grotesk';
    font-size: 16px;
    font-weight: 600;
    color: @title-color;
    margin-bottom: 6px;
}

.titleSmall {
    font-family: 'Hanken Grotesk';
    font-size: 14px;
    font-weight: 600;
    color: @title-color;
    margin-top: 16px;
    margin-bottom: 6px;
}

.input {
    width: 100%;
    padding: 10px 12px;
    background-color: #fafafa;
    border: 1px solid #e3e6eb;
    border-radius: 10px;
    font-family: 'Hanken Grotesk';
    font-size: 15px;
    color: #222;
    resize: vertical;
    &:focus {
        border-color: #2075f4;
        outline: none;
    }
}

.seperator {
    width: 100%;
    height: 1px;
    background-color: #e3e6eb;
    margin: 0px 0;
    margin-bottom: 20px;
}

.cancelButton {
    .baseNoButton();
}

.confirmButton {
    .baseYesButtonStyle();
}

.labelRow {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 16px;
    margin-bottom: 6px;

    .titleSmall {
        margin: 0;
    }
}

.helpTooltip {
    --rt-color-dark: #1a2f4a;
    --rt-color-white: #ffffff;
    --rt-opacity: 1;
    border-radius: 8px;
    padding: 6px 12px;
    font-family: 'Hanken Grotesk';
    font-size: 14px;
    font-weight: 500;
    z-index: 2000;
}

.helpIcon {
    width: 14px;
    height: 14px;
    cursor: help;
    opacity: 0.25;
    transition: opacity 0.5s ease-in-out;
    &:hover {
        .filterBlue();
        opacity: 1;
    }
}
